import { runUnitTests } from "@excitare/cli-command-test";

/*
 * This is the entry point to the forked unit testing process
 */

runUnitTests(true, process.env.projectDir);
